import Vue from "vue";

Vue.directive("lazy-load-dropdown", {
  bind(el, binding) {
    const SELECT_DOM = el.querySelector('.el-select-dropdown .el-scrollbar__wrap')
    // SELECT_DOM 获取到的dmo节点 下面需要用到dmo节点的clientHeight
    SELECT_DOM.addEventListener('scroll', () => {
      if (SELECT_DOM.scrollTop + SELECT_DOM.clientHeight >= SELECT_DOM.scrollHeight) {
        binding.value()
      }
    })
  }
})
  